import { useRef } from 'react'
import { createTreeStore } from './store/tree-store'
import { TreeStoreContext } from './context'

export function TreePlusPlusProvider(props: {
  children: React.ReactNode
}) {
  const treeStoreRef = useRef<ReturnType<typeof createTreeStore>>()
  if (treeStoreRef.current == null) {
    treeStoreRef.current = createTreeStore()
  }

  return (
    <TreeStoreContext.Provider value={treeStoreRef.current}>
      {props.children}
    </TreeStoreContext.Provider>
  )
}
